module.exports = __webpack_public_path__ + "media/images/default/shared/header/bg-md-f1db20cba56f64486179e1130376e2b8.svg";